import { render, staticRenderFns } from "./B2BTracking.vue?vue&type=template&id=3ad1f0b1"
import script from "./B2BTracking.vue?vue&type=script&lang=js"
export * from "./B2BTracking.vue?vue&type=script&lang=js"
import style0 from "./B2BTracking.vue?vue&type=style&index=0&id=3ad1f0b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports